const menuNavGrid = () => {
	const $items = $('.menu__nav > ul > li');
	const $firstCol = $('.menu__nav__inner ul:nth-child(1)');
	const $secondCol = $('.menu__nav__inner ul:nth-child(2)');
	const $thirdCol = $('.menu__nav__inner ul:nth-child(3)');

	let colCounter = 1;

	$items.each(function() {
		const $item = $(this);

		switch(colCounter) {
			case 2:
				$item.appendTo($secondCol);
				break;
			case 3:
				$item.appendTo($thirdCol);
				break;
			default:
				$item.appendTo($firstCol);
		}

		if (colCounter === 3) {
			colCounter = 1;
		} else {
			colCounter++
		}
	});

	$('.menu__nav > ul').remove();
}

const menuNavDropdowns = () => {
	$('.menu__nav__inner ul ul').closest('li').addClass('has-dropdown');

	/*$('.has-dropdown > a').on('click', function(event) {
		event.preventDefault();

		const $btn = $(this);

		$btn.toggleClass('active');

		$btn.next().slideToggle();
	})*/
}

const moveSecondaryNav = () => {
	if ( $('.header-bar .nav-secondary') ) {
		$('.header-bar .nav-secondary ul').clone().appendTo('.menu__nav-secondary');
	}
}

const hideNavItems = () => {
	const $nav = $('.js-hide-nav-items');
	const $navItems = $('.js-hide-nav-items > ul > li');
	const count = Number($nav.data('count'));

	if (count) {
		$navItems.each((index, item) => {
			if (index >= count) {
				$(item).addClass('d-none');
			}
		})
	}
}

export default function menuUI() {
	// menuNavGrid();

	menuNavDropdowns();

	// moveSecondaryNav();

	hideNavItems();
}
